import { makeAutoObservable } from "mobx";
import { DecisionContext } from "@/dbot/common/commonDomain";
import { DecisionType } from "@/common/decisions";

export type DissolveCompany = {
  type: DecisionType.dissolveCompany;
};

export class DissolveCompanyForm {
  readonly type = DecisionType.dissolveCompany;

  constructor(readonly context: DecisionContext<DissolveCompany>) {
    makeAutoObservable(this, { type: false, context: false }, { autoBind: true });
  }

  get isProjectLocked(): boolean {
    return this.context.isLocked;
  }
}
